import { memo } from 'react';
import { Accordion, Col, Form, Row } from 'react-bootstrap';
import { Control, useForm, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// 全ての状態、有効、無効
const ACTIVE_SOURCE = [
  { value: '0', label: '全ての状態' },
  { value: '1', label: '有効' },
  { value: '2', label: '無効' },
];

export interface SearchDisplayTimingGroupFilter {
  group_name: string;
  active: string;
}

interface DisplayTimingGroupFilterProps {
  onFilter?: (data: SearchDisplayTimingGroupFilter) => void;
}

function DisplayTimingGroupFilter({ onFilter }: DisplayTimingGroupFilterProps) {
  const { t } = useTranslation();

  const {
    register,
    handleSubmit,
    control,
    formState: { isSubmitting },
  } = useForm<SearchDisplayTimingGroupFilter>({
    defaultValues: {
      group_name: '',
      active: '0',
    },
  });

  function handleSearchSubmit(data: SearchDisplayTimingGroupFilter) {
    onFilter?.(data);
  }

  return (
    <Accordion className="mb-3" defaultActiveKey={['0', '1', '2']} alwaysOpen>
      <Accordion.Item eventKey="0" className="movement-information">
        <Accordion.Header>{t('MenuList.Filter.filter_condition')} </Accordion.Header>
        <Accordion.Body>
          <Form onSubmit={handleSubmit(handleSearchSubmit)}>
            <Row>
              <Col sm={'auto'}>
                <Form.Label htmlFor="txt-group-name" className="col-form-label">
                  {t('DisplayTimingGroup.group_name')}：
                </Form.Label>
              </Col>
              <Col sm={'auto'}>
                <Form.Control id="txt-group-name" {...register('group_name')} className="col-auto" />
              </Col>
              <Col sm={'auto'}>
                <Form.Select id="cbo-active" className="text-center" {...register('active')}>
                  {ACTIVE_SOURCE.map((item) => {
                    return (
                      <option key={item.value} value={item.value}>
                        {item.label}
                      </option>
                    );
                  })}
                </Form.Select>
              </Col>
              <Col sm={'auto'}>
                <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                  {t('DisplayTimingGroup.search')}
                </button>
              </Col>
            </Row>
          </Form>
        </Accordion.Body>
        <div className="accordion-body accordion-summary">
          <Row>
            <GroupNamePreview control={control} />
            <ActivePreview control={control} />
          </Row>
        </div>
      </Accordion.Item>
    </Accordion>
  );
}

function GroupNamePreview({ control }: { control: Control<SearchDisplayTimingGroupFilter, any> }) {
  const { t } = useTranslation();
  const groupName = useWatch({ control, name: 'group_name' });

  return (
    <Col sm={'auto'}>
      <Form.Label className="col-form-label">{t('DisplayTimingGroup.group_name')}</Form.Label>：
      <Form.Label className="col-form-label">{groupName || '-'}</Form.Label>
    </Col>
  );
}

function ActivePreview({ control }: { control: Control<SearchDisplayTimingGroupFilter, any> }) {
  const { t } = useTranslation();
  const active = useWatch({ control, name: 'active' });

  return (
    <Col sm={'auto'}>
      <Form.Label className="col-form-label">{t('DisplayTimingGroup.status')}</Form.Label>：
      <Form.Label className="col-form-label">{ACTIVE_SOURCE.find((item) => item.value === active)?.label}</Form.Label>
    </Col>
  );
}

export default memo(DisplayTimingGroupFilter);
